import React, { useEffect, useState } from "react";
import "./AddAddressModal.css";
import { Accordion, Form, Modal, Row } from "react-bootstrap";
import OrangeFilledSquareBtn from "../../Common_Btn/OrangeFilledSquareBtn/OrangeFilledSquareBtn";
import OrangeOutlineGrayFilledBtn from "../../Common_Btn/OrangeOutlineGrayFilledBtn/OrangeOutlineGrayFilledBtn";
import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";
import Orange_Round_Arrow_Btn from "../../Common_Btn/Orange_Round_Arrow_Btn/Orange_Round_Arrow_Btn";
import Select from "react-select";
import Select_Dropdown_holder from "../../Select_Dropdown_holder/Select_Dropdown_holder";
import { RegxExpression } from "../../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import {
  createOrderAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getAllSippingOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";
import {
  AllCity,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
function EditAddressModal({GetData, data, baseLink, ...props }) {
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();
  const dispatch = useDispatch();

  // const product = useSelector((state) => state.product.product);
  // useEffect(() => {
  //   if (id) { // Ensure ID is valid before dispatching
  //     dispatch(getSingleOrderAddress(id ));
  //   }
  // }, [dispatch, id]);
  

  // useEffect(() => {
  //   if (data?.country_id) {
  //     dispatch(AllState(data.country_id));
  //   }
  //   if (data?.state_id) {
  //     dispatch(AllCity(data.state_id));
  //   }
  //   if (data?.pincode_id) {
  //     dispatch(AllPincode(data.pincode_id));
  //   }

  //   reset({
  //     ...data,
  //     country_id: data.country_id || null,
  //     state_id: data.state_id || null,
  //     city_id: data.city_id || null,
  //     pincode_id: data.pincode_id || null,
  //   });
  // }, [data,reset,dispatch]);
  useEffect(() => {
    if (data) {
      reset({
        ...data,
        country_id: data.country_id?.value
          ? data.country_id
          : { value: data.Country?.id, label: data.Country?.name } || null,
        state_id: data.state_id?.value
          ? data.state_id
          : { value: data.State?.id, label: data.State?.name } || null,
        city_id: data.city_id?.value
          ? data.city_id
          : { value: data.City?.id, label: data.City?.name } || null,
        pincode_id: data.pincode_id?.value
          ? data.pincode_id
          : { value: data.Pincode?.id, label: data.Pincode?.name } || null,
      });

      // Manually update values to force UI re-render
      setValue(
        "country_id",
        data.country_id?.value
          ? data.country_id
          : { value: data.Country?.id, label: data.Country?.name,name:"country_id" } || null
      );
      setValue(
        "state_id",
        data.state_id?.value
          ? data.state_id
          : { value: data.State?.id, label: data.State?.name ,name: "state_id" } || null
      );
      setValue(
        "city_id",
        data.city_id?.value
          ? data.city_id
          : { value: data.City?.id, label: data.City?.name,name: "city_id"} || null
      );
      setValue(
        "pincode_id",
        data.pincode_id?.value
          ? data.pincode_id
          : { value: data.Pincode?.id, label: data.Pincode?.name ,name: "pincode_id" } || null
      );
    }
  }, [data, reset, setValue]);

 

  const onSubmit = async (d) => {
    d.country_id = d?.country_id.value;
    d.state_id = d?.state_id.value;
    d.city_id = d?.city_id.value;
    d.pincode_id = d?.pincode_id.value;
    const res = await dispatch(EditOrderAddress(d));
    dispatch(getAllOrderAddress());
    dispatch(getAllSippingOrderAddress());
    // dispatch(getSingleOrderAddress(d.id));
    // GetData(d.id);
    props.onHide();
  

    
  };

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption.value }));
  };

  const handleStateChange = (selectedOption) => {
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    setValue("pincode_id", selectedOption?.value);
  };
  return (
    <section className="AddAddressModal modal-holder">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="AddAddressModal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Address</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="main_modal_div">
            <div className="form_holder">
              <Form onSubmit={handleSubmit(onSubmit)}>
                <div className="address_form">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Form.Group className="form-group">
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Full Name"
                          {...register("name", {
                            required: "First name required",
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.name,
                            "is-valid": getValues("name"),
                          })}
                        />
                        {errors?.name && (
                          <sup className="text-danger">
                            {errors?.name?.message}
                          </sup>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Form.Group className="form-group">
                        <Form.Control
                          type="text"
                          name="email"
                          placeholder="Email"
                          {...register("email", {
                            required: "Email is required",
                            pattern: {
                              value: RegxExpression.email,
                              message: "Invalid email ",
                            },
                          })}
                          className={classNames("", {
                            "is-invalid": errors?.email,
                            "is-valid": getValues("email"),
                          })}
                        />
                        {errors?.email && (
                          <sup className="text-danger">
                            {errors?.email?.message}
                          </sup>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Form.Group className="form-group">
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter Company"
                          {...register("company_name", {
                            required: "Company is required",
                          })}
                          className={classNames("", {
                            "is-valid": getValues("company_name"),
                          })}
                        />
                        {errors?.company_name && (
                          <span className="invalid-feedback d-block">
                            {errors.company_name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Form.Group className="form-group">
                        <Controller
                          name="contact_no"
                          control={control}
                          rules={{
                            required: "Contact number is required",
                            minLength: {
                              value: 10,
                              message:
                                "Number should be at least 10 characters",
                            },
                          }}
                          render={({ field }) => (
                            <Form.Control
                              {...field}
                              className={classNames("", {
                                "is-invalid": errors?.contact_no,
                                "is-valid": getValues("contact_no"),
                              })}
                              // onChange={(value) => field.onChange(value)}
                              type="text"
                              placeholder="Mobile Number"
                              maxLength={10}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                ); // Removes non-numeric characters
                                field.onChange(numericValue);
                              }}
                            />
                          )}
                        />
                        {errors?.contact_no && (
                          <sup className="text-danger">
                            {errors?.contact_no?.message}
                          </sup>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <Form.Group className="form-group">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Address Line 1"
                      {...register("address_one", {
                        required: "Address Line 1 is required",
                      })}
                      className={classNames("", {
                        "is-valid": getValues("address_one"),
                      })}
                    />
                    {errors?.address_one && (
                      <span className="invalid-feedback d-block">
                        {errors.address_one.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group className="form-group">
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Address Line 2"
                      {...register("address_two", {
                        required: "Address Line 2 is required",
                      })}
                      className={classNames("", {
                        "is-valid": getValues("address_two"),
                      })}
                    />
                    {errors?.address_two && (
                      <span className="invalid-feedback d-block">
                        {errors.address_two.message}
                      </span>
                    )}
                  </Form.Group>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Controller
                       className="Select_Dropdown_holder"
                        name="country_id" // Form field name
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            className="Select_Dropdown_holder__select"
                            classNamePrefix="custom-select"
                            {...field}
                            placeholder={"Country"}
                            option={countries}
                            handleChange={handleCountryChange}
                            onInputChange={(val) => {
                              dispatch(getAllCountries(val));
                            }}
                          />
                        )}
                      />
                      {errors?.country_id && (
                        <span className="invalid-feedback d-block">
                          {errors.country_id.message}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Controller
                        className="Select_Dropdown_holder"
                        name="state_id" // Form field name
                        control={control}
                        rules={{ required: "State is required" }}
                        render={({ field }) => (
                          <Select
                            className="Select_Dropdown_holder__select"
                            classNamePrefix="custom-select"
                            {...field}
                            placeholder={"State"}
                            option={states}
                            handleChange={handleStateChange}
                            onInputChange={(val) => {
                              const countryId = getValues("country_id");
                              dispatch(
                                AllState({ countryId: countryId, name: val })
                              );
                            }}
                          />
                        )}
                      />
                      {errors?.state_id && (
                        <span className="invalid-feedback d-block">
                          {errors.state_id.message}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Controller
                        className="Select_Dropdown_holder"
                        name="city_id" // Form field name
                        control={control}
                        rules={{ required: "City is required" }}
                        render={({ field }) => (
                          <Select
                            className="Select_Dropdown_holder__select"
                            classNamePrefix="custom-select"
                            {...field}
                            placeholder={"City"}
                            option={cities}
                            handleChange={handleCityChange}
                            onInputChange={(val) => {
                              const stateId = getValues("state_id");
                              dispatch(
                                AllCity({ stateId: stateId, name: val })
                              );
                            }}
                          />
                        )}
                      />
                      {errors?.city_id && (
                        <span className="invalid-feedback d-block">
                          {errors.city_id.message}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-6">
                      <Controller
                       className="Select_Dropdown_holder"
                        name="pincode_id" // Form field name
                        control={control}
                        rules={{ required: "Pincode is required" }}
                        render={({ field }) => (
                          <Select
                            className="Select_Dropdown_holder__select"
                            classNamePrefix="custom-select"
                            {...field}
                            placeholder={"Pincode"}
                            option={pincodes}
                            handleChange={handlePincodeChange}
                            onInputChange={(val) => {
                              const pincodeId = getValues("city_id");
                              dispatch(
                                AllCity({ cityId: pincodeId, name: val })
                              );
                            }}
                          />
                        )}
                      />
                      {errors?.pincode_id && (
                        <span className="invalid-feedback d-block">
                          {errors.pincode_id.message}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="save_btn">
                  <Orange_Round_Arrow_Btn
                    btn_name="Save This Address"
                    type={"submit"}
                  />
                </div>
              </Form>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
}

export default EditAddressModal;
